import { render, staticRenderFns } from "./bulma_simpletable.vue?vue&type=template&id=26b33db2&scoped=true&lang=html"
import script from "./bulma_simpletable.vue?vue&type=script&lang=js"
export * from "./bulma_simpletable.vue?vue&type=script&lang=js"
import style0 from "./bulma_simpletable.vue?vue&type=style&index=0&id=26b33db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b33db2",
  null
  
)

export default component.exports